import React, { useState } from "react";
import {
	Button,
	Tag,
	Icon,
	TextArea,
} from "@blueprintjs/core";
import { delay } from "ui-lib";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";
import { TASKS_QUERY_FILTER } from "ui-io/queries/tasks/task-query";
import { TaskT } from "ui-io/task-io/task-t";
import { taskComplexAddMutation } from "ui-io/queries/tasks/task-complex-add-mutation";
import { ReferenceT } from "ui-io/task-io";
import { Atom, useAtom } from "klyva";
import { Box } from "ui-components";

import toasts from "../../../utils/toasts";
import { AcceptedFile } from ".";
import { date } from "io-ts-types";
import useSession from "ui-io/use-session";
type NewMessageProps = {
	task: TaskT;
	handleToggleUpload: () => void;
	acceptedFilesAtom: Atom<AcceptedFile[]>;
	referencesToAdd: ReferenceT[];
};

const AddNewComment = (props: NewMessageProps) => {
	const {
		task,
		handleToggleUpload,
		acceptedFilesAtom,
		referencesToAdd,
	} = props;
	const [comment, setComment] = React.useState("");
	const queryClient = useQueryClient();
	const { session } = useSession();
	const  username  = session?.username ?? "";
	const [acceptedFiles, setAcceptedFiles] = useAtom(acceptedFilesAtom);

	const mutation = useMutation(taskComplexAddMutation, {
		onError: (error) => {
			toasts.error(`${error}`);
		},
		onSuccess: async () => {
			toasts.success("Successfully saved comment");
			setComment("");
			await delay(500);
			setAcceptedFiles(() => []);
			queryClient.refetchQueries([TASKS_QUERY_FILTER,task.id]);
		},
	});

	const handleOnSubmit = (
		event:
			| React.FormEvent<HTMLFormElement>
			| React.MouseEvent<HTMLElement, MouseEvent>
	) => {
		event.preventDefault();

		mutation.mutate({
			taskId: task.id,
			companyID: task?._raw.companyID ?? "",
			body: {
				companyID: task?._raw.companyID ?? "",
				taskId: task.id,
				text: comment,
				user: username,
				timestamp: Date.now(),
				tags:[{key: "MANUAL",
					value: "MANUAL"}],
				references: acceptedFiles.length > 0 ? Object.values(acceptedFiles).map((file:any) => file.reference as ReferenceT) : undefined,
			},
		});
	};

	return (
		<>
			<NewMessageWrapper>
				<Box ml={"large"} flexDir="row" items="start"> 
					<Box ml={"large"} flexDir="row" items="start">
						{acceptedFiles.length > 0
							? acceptedFiles.slice(0, 6).map((file, index) => {
									const fileExtension = file.file.name.split(".").pop()?.toLowerCase();
									const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

									if (imageExtensions.includes(fileExtension || "")) {
										return (
											<Tag key={index} minimal>
												<img
													src={
														file?.reference?.reference_type === "URL"
															? (file.reference as any)?.url_reference.fileUrl
															: ""
													}
													alt={file.name}
													width={40}
													height={50}
												/>
											</Tag>
										);
									} else {
										return (
											<Tag
												key={index}
												intent="primary"
												className="h-40 w-60 ml-xs text-center"
											>
												{fileExtension}
											</Tag>
										);
									}
								})
							: null}
						{acceptedFiles.length > 7 && (
							<Tag size="large" minimal className="ml-md text-center">
								...
							</Tag>
						)}
					</Box>

				</Box>
				<Box
					flexDir="row"
					items="start"
					flex="1"
					style={{ position: "relative", top: "0px" }}
				>
					{acceptedFiles.length ? (
						<Tag
							interactive
							minimal
							intent="primary"
							onClick={handleToggleUpload}
						>
							<Icon
								icon="paperclip"
								intent="primary"
							/>
							{acceptedFiles.length}
						</Tag>
					) : (
						<Button onClick={handleToggleUpload} icon="paperclip" />
					)}
					<Box flex="1" ml="small" mr="small">
						<TextArea
							value={comment}
							placeholder="Enter your comment here"
							onChange={(event) => setComment(event.target.value)}
							disabled={mutation.isLoading}
							fill
							growVertically={true}
							style={{ maxHeight: "70px" }}
						/>
					</Box>
					<Button
						intent="primary"
						onClick={handleOnSubmit}
						icon="send-message"
						loading={mutation.isLoading}
						type="submit"
						disabled={comment.trim().length === 0 && acceptedFiles.length === 0}
					/>
				</Box>
			</NewMessageWrapper>
		</>
	);
};

const NewMessageWrapper = styled.div`
  // display: flex;

  // border-top-style: solid;
  // border-top-width: 1px;
 
  // padding: 20px;
  // padding-top: 30px;
  // margin-left: -20px;
  // margin-bottom: -20px;
  // position: absolute;
  // bottom: 20px;
  // width: 100%;
  // z-index: 4;
	  margin: 20px;
`;

export default AddNewComment;
